import config from '../config';

function startConversation(message) {
  const link = ['mailto:', config.url.supportEmailAddress];

  if (message !== undefined) {
    link.push('?subject=');
    link.push(message);
  }

  window.location = link.join('');
}

export default { startConversation };



// WEBPACK FOOTER //
// ./src/lib/intercom.js